(() => {
  function init(scope) {
    scope.querySelectorAll('.c_factory-article-long-sellers').forEach((root) => {
      if (root.dataset.scrollReady) return;
      root.dataset.scrollReady = 'true';
      const list = root.querySelector('.c_factory-article-long-sellers__list');
      const controls = root.querySelector('[data-long-seller-controls]');
      const slider = root.querySelector('.c_factory-article-long-sellers__slider');
      const image = root.querySelector('.c_product-item__image-wrapper');
      const prev = root.querySelector('[data-long-seller-prev]');
      const next = root.querySelector('[data-long-seller-next]');
      if (!list || !controls || !prev || !next) return;
      const sync = () => {
        const max = list.scrollWidth - list.clientWidth;
        controls.hidden = max <= 1;
        prev.disabled = list.scrollLeft <= 1;
        next.disabled = list.scrollLeft >= max - 1;
        if (slider && image && image.clientHeight > 0) {
          const top = image.getBoundingClientRect().top - slider.getBoundingClientRect().top + image.clientHeight / 2;
          prev.style.top = next.style.top = `${top}px`;
        }
      };
      const scroll = (direction) => list.scrollBy({
        left: direction * list.clientWidth * 0.8,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      prev.addEventListener('click', () => scroll(-1));
      next.addEventListener('click', () => scroll(1));
      list.addEventListener('scroll', sync, { passive: true });
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(sync);
        observer.observe(list);
        if (image) observer.observe(image);
      }
      else window.addEventListener('resize', sync);
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
